<template>
  <div class="infomation-area">
    <div class="infomation-block">
      <h2>何ができる？</h2>
      <ul>
        <li>自分のブログページと競合ページに含まれる単語の重要度を比較できます。</li>
        <li>自分のブログページに不足している単語を把握し、その単語を取り込むことで”SEO”に役立ちます。多分。</li>
        <li>競合ページの単語を眺めるだけでも新たな発見ができ、自分のブログを充実させることができます。きっと。</li>
      </ul>
    </div>
    <div class="infomation-block">
      <h2>単語の重要度とは？</h2>
      <ul>
        <li>TF-IDFという手法を用いて、文書に含まれる単語の出現頻度をもとにその単語の重要度を数値化したものです。</li>
        <li>TF-IDF＝term frequency–inverse document frequencyの略。<a href="https://ja.wikipedia.org/wiki/Tf-idf">tf-idf - Wikipedia</a>
        </li>
      </ul>
    </div>
    <div class="infomation-block">
      <h2>どう使うの？</h2>
      <ul>
        <li>トップのボックスの中に比較したいページのURLを1行ずつ改行して入力してください。</li>
        <li>1行目に自分のページを入力してください。</li>
        <li>2行目以降に比較したいページを入力してください。</li>
        <li>最大5行まで比較します（6行目以降は無視します）。</li>
        <li>重複するURLは自動的に除去します。</li>
        <li>アクセスできないページは自動的に除去します。</li>
      </ul>
    </div>
    <div class="infomation-block">
      <h2>比較結果について</h2>
      <ul>
        <li>比較結果の数値は重要度を表します。数値が大きい方がより重要。</li>
        <li>初期表示は、自分のページにおける重要度と競合ページにおける重要度の差が0.1以上の単語を表示しています。（競合ページが複数ある場合は少なくとも1つの競合ページに対して0.1以上なら表示）</li>
        <li>左上のボタンで”すべての単語”を表示するか、”重要度の差が0.1以上の単語”に絞るかを切り替えることができます。</li>
        <li>表は列名をクリックすることで並び替えることができます。</li>
        <li>Shiftキーを押しながらクリックすることで、複数列での並び替えができます。</li>
        <li>比較結果は右上のダウンロードボタンでCSVファイルにダウンロードできます。</li>
        <li>ダウンロードしたファイルの一番右の列は、自分のページにおける重要度と競合ページにおける重要度の差が0.1以上の単語かどうかを表します。Trueが0.1以上、Falseが0.1未満の単語。</li>
        <li>指定されたURLから本文がどこまでなのかは判断が難しく、中には本文に関係のない単語が含まれることがあります。</li>
        <li>一部のサイト（プログラムによる取得をブロックするサイトなど）では文章を取得できずエラーになります。</li>
      </ul>
    </div>
    <div class="infomation-block">
      <h2>その他</h2>
      <ul>
        <li>もちろん無料です。</li>
        <li>回数など使用制限はありません。</li>
        <li>比較された情報は記録・取得しておらずいかなる2次利用もありません。</li>
        <li><span class="material-symbols-outlined">face</span>「実際に検索順位があがった実績はあるの？」<br><span class="material-symbols-outlined rotate">pan_tool_alt</span><a href="https://inmylife65.net/quick-solution-excel-vlookup-2888">このページ</a>はこの方法でキーワードを増やしていった結果、1ヶ月半くらいで7位から2位になりましたが、他のSEO対策同様これをやったからそのような結果が得られた、という保証はありません。</li>
        <li><span class="material-symbols-outlined">face</span>「URLをわざわざ入力させるのではなく、キーワードから上位ページを自動で取得したらいいんじゃないの？」<br><span class="material-symbols-outlined rotate">pan_tool_alt</span>そうしたいのは山々ですが、Googleの検索結果をプログラムで取得するには結構<span class="material-symbols-outlined">paid</span>がかかるので難しいです。</li>
        <li>ご要望、ご質問、不具合のご報告などあれば<a href="https://forms.gle/GGpUbnRvrnMfc9j18">こちら</a>にお願いします。</li>
      </ul>
    </div>
  </div>
  <hr>
  <div class="others">
    <div @click="toggleOthers"><h2>このページの技術情報<span class="material-symbols-outlined">expand_more</span></h2></div>
    <div ref="techDetail">
        <ul v-if="showOthers">
        <li>SPAフレームワークとして<a href="https://v3.ja.vuejs.org/">Vue.js</a></li>
        <li>比較結果の表は<a href="http://tabulator.info/">Tabulator</a></li>
        <li>TF-IDFの算出は<a href="https://scikit-learn.org/stable/index.html">scikit-learn</a>のTfidfVectorizer</li>
        <li>HTMLから文書の抽出は<a href="https://pypi.org/project/extractcontent3/">extractcontent3</a></li>
        <li>文書から単語の抽出は<a href="https://pypi.org/project/mecab/">Mecab</a></li>
        <li>...ということで多くの優れたライブラリの寄せ集めであって作者自身は何も難しいことは作成しておりません...ライブラリの作成者に心から感謝します。</li>
        </ul>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from "vue";

export default {
  setup() {
    const showOthers = ref(false);
    const techDetail = ref(null)

    const toggleOthers = async () => {
        showOthers.value = !showOthers.value
        await nextTick()
        techDetail.value.scrollIntoView({block: "end"});;
    }
    return {showOthers, toggleOthers, techDetail}
  }
}
</script>
<style>
  .infomation-area {
    margin: 10px 20px;
    line-height: 2em;
    padding: 0 4%;
    /* letter-spacing: 1px; */
  }
  .infomation-area a {
    color:var(--link);
    text-decoration: underline dotted;
  }
  .infomation-area a:hover {
    color:var(--primary);
  }
  .others {
    margin: 10px 20px;
    font-size: small;
    line-height: 2em;
  }
  .others h2 {
    font-size: 1.2em;
  }
  h2 {
    margin-bottom: 10px;
  }
  ul {
    margin-left: 20px;
  }
  .infomation-block {
    background: white;
    margin-bottom: 20px;
    padding: 10px 30px;
    border-radius: 8px;
  }
</style>